__turbopack_context__.v({
  "contractTemplateIcon": "_8QfJ-W_contractTemplateIcon",
  "root": "_8QfJ-W_root",
});
